import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {StaticTextComponent, StaticImageComponent} from './component';

export class StaticContentModel extends BaseContentModel {

    static get _slots() {
        return {
            css: "",
        };
    }

    static get _defaults() {
        return {
            css: "",
        };
    }

    @observable
    /* @slot */ css = "";
}

export class StaticTextContentModel extends StaticContentModel {

    static get _slots() {
        return Object.assign({}, StaticContentModel._slots, {
            content: "RichText"
        });
    }

    static get _defaults() {
        return Object.assign({}, StaticContentModel._defaults, {
            content: ""
        });
    }

    Component = StaticTextComponent;

    @observable
    /* @slot */ content = "";
}

export class StaticImageContentModel extends StaticContentModel {

    static get _slots() {
        return Object.assign({}, StaticContentModel._slots, {
            source: "",
            alternate: "",
            width: "",
            height: "",
        });
    }

    static get _defaults() {
        return Object.assign({}, StaticContentModel._defaults, {
            source: "",
            alternate: "",
            width: "auto",
            height: "auto",
        });
    }

    Component = StaticImageComponent;

    @observable
    /* @slot */ source = "";

    @observable
    /* @slot */ alternate = "";

    @observable
    /* @slot */ width = "auto";

    @observable
    /* @slot */ height = "auto";
}


export default StaticTextContentModel;



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/static/contentmodel.js